import { HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';
import { inject } from '@angular/core';
import { FeatureService } from '@services/feature-toggle/feature.service';

export function errorInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const authService: AuthService = inject(AuthService);
    const featureService: FeatureService = inject(FeatureService);
    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 403) {
                featureService.refreshAccessMap();
            }
            if (error.status === 401) {
                // This is normal flow below:
                if (!authService.isUpdatingEmail()) {
                    authService.signOut();
                }
            }
            return throwError(() => error);
        })
    );
}
